'use client'

import { initClientSdks } from '~/lib/init-client-sdks'

// Must run in the client bundle — root layout is a Server Component,
// so init there only mutates the server axios instance (prod default stays).
initClientSdks()

export const InitSdks = () => null
